export default __webpack_public_path__ + "static/JamesCastle-6238bf535e64a1f96bf9f371cb02ff2a.png";